/**
 * Created by pajicv on 10/9/18.
 */
import React from 'react';
import { Card, CardContent, Typography, Button, Avatar, Tooltip, withStyles } from '@material-ui/core';
import {MAIN_COLOR} from '../../firebase-config';

const styles = theme => ({
   container: {
       width: 300,
       height: 200,
   },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    document: {
       width: '80%',
        height: 40,
        textAlign: 'center',
    },
    avater: {
       margin: 10
    },
    button: {
       margin: 10
    }
});

const ManagerViewUploadedDocument = ({ assignedTo, docUrl, taskName, classes }) => {
    const email = window.atob(assignedTo);
    return (
        <Card className={classes.container}>
            <CardContent className={classes.card}>
                <div className={classes.document}>
                    <Typography variant="title">{taskName}</Typography>
                </div>
                <Tooltip title={email}>
                    <Avatar
                        className={classes.avatar}
                        style={{backgroundColor: MAIN_COLOR, width: 40, height: 40}}
                    >
                        {email.substring(0, 2).toUpperCase()}
                    </Avatar>
                </Tooltip>
                <Button
                    className={classes.button}
                    color="primary"
                    variant="contained"
                    aria-label="Download"
                    target="_blank"
                    href={docUrl}
                >
                    <Typography>Download</Typography>
                </Button>
            </CardContent>
        </Card>
    );
};

export default withStyles(styles)(ManagerViewUploadedDocument);



// WEBPACK FOOTER //
// ./src/components/Tasks/ManagerViewUploadedDocuments.js